import { AgentAvatar } from "@/components/molecules/agent-avatar";
import { usePublicTranslation } from "@/features/utils/i18n";

interface ChatEmptyStateProps {
  agentName?: string;
  clientName?: string;
  clientLogo?: string | null;
}

// Branded welcome shown before the first message. Keeps the empty chatbox feeling
// alive and on-brand instead of a bare "Start a conversation" line.
export function ChatEmptyState({
  agentName,
  clientName,
  clientLogo,
}: ChatEmptyStateProps) {
  const { t } = usePublicTranslation();
  const name = agentName || clientName;

  return (
    <div className="flex flex-col items-center justify-center gap-4 px-6 py-10 text-center animate-fade-in-up">
      <AgentAvatar
        name={name}
        logo={clientLogo}
        className="size-16"
        online
      />
      <div className="space-y-1">
        <p className="text-base font-semibold">
          {name ? t("chat.welcome_named", { name }) : t("chat.welcome")}
        </p>
        <p className="mx-auto max-w-xs text-sm text-muted-foreground">
          {agentName
            ? t("chat.welcome_hint_named", { name: agentName })
            : t("chat.welcome_hint")}
        </p>
      </div>
    </div>
  );
}
